import React, { useState, useEffect, useRef } from 'react';
import {
  TextField,
  Button,
  Checkbox,
  Container,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Typography,
  Box,
  MenuItem,
  Select
} from '@mui/material';
import { QRCodeSVG } from 'qrcode.react';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import {
  getActiveReaders,
  postRequest,
  ticketSendEmail,
  getMode,
  getCameraMode,
  getTemplateGroups,
  getTicketTemplates,
  getPeriods
} from '../../api/axios';
import Error from '../Error/Error';
import Success from '../Success/Success';
import { useTranslation } from 'react-i18next';
import { getUsername } from '../../context/AuthFunc';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { getParkingMapDataUrl } from '../../assets/parkingMap';
import '../../fonts/CoFoPeshka260-260Black.otf';
import './qrgenerateticket.css';
import CZLogo from '../Logo/CZLogo.jsx';
const QRGenerateTicket = () => {
  const { t } = useTranslation('global');

  const [surname, setSurname] = useState('');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [hFrom, setHFrom] = useState('08:00');
  const [hTo, setHTo] = useState('19:00');
  const [dayNo, setDayNo] = useState('30');
  const [entryNo, setEntryNo] = useState('30');
  const [dailyNo, setDailyNo] = useState('0');
  const [ticketCount, setTicketCount] = useState('1');
  const [email, setEmail] = useState('');
  const [readers, setReaders] = useState([]);
  const [selectedReaders, setSelectedReaders] = useState([]);
  const [errMsg, setErrMsg] = useState('');
  const [succ, setSucc] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isTicketModalOpen, setIsTicketModalOpen] = useState(false);
  const [qrCodes, setQrCodes] = useState([]);
  const [tickets, setTickets] = useState([]); // Čuva podatke o svim generisanim kartama
  const [templateGroups, setTemplateGroups] = useState([]);
  const [selectedTemplateGroup, setSelectedTemplateGroup] = useState('');
  const [ticketTemplates, setTicketTemplates] = useState([]);
  const [selectedTicketTemplate, setSelectedTicketTemplate] = useState('');
  const [registrationPlates, setRegistrationPlates] = useState('');
  const [readerGroup, setReaderGroup] = useState('');
  const [periods, setPeriods] = useState([]);
  const [selectedPeriods, setSelectedPeriods] = useState([]);
  const [isPeriodsModalOpen, setIsPeriodsModalOpen] = useState(false);

  const [mode, setMode] = useState('0');
  const [cameraMode, setCameraMode] = useState('0');
  const [changeTime, setChangeTime] = useState(() => {
    const today = new Date().toISOString().split('T')[0];
    return `${today} 00:00:00`;
  });
  const ticketRefs = useRef([]);

  const [isAllPdfGenerated, setIsAllPdfGenerated] = useState(false);
  const [pdfFiles, setPdfFiles] = useState([]);

  const [isFullSize, setIsFullSize] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const readers = await getActiveReaders();
        const groups = await getTemplateGroups();
        const templates = await getTicketTemplates();
        const periodsData = await getPeriods();
        const mode = await getMode();
        const cameraMode = await getCameraMode();
        setMode(mode);
        setCameraMode(cameraMode);
        setTemplateGroups(groups || []);
        setTicketTemplates(templates || []);
        setReaders(readers);
        setSelectedReaders(readers.map(reader => reader.id));
        setPeriods(Array.isArray(periodsData) ? periodsData : []);
      } catch (error) {
        console.error(t('newTicket.errorFetchingReaders'), error);
      }
    };

    fetchData();
  }, []);
  const generatePDF = async index => {
    const ticketElement = ticketRefs.current[index];
    if (!ticketElement) {
      return null;
    }
    // Pretvaranje DOM elementa u sliku
    const canvas = await html2canvas(ticketElement, {
      allowTaint: true,
      useCORS: true
    });
    const imgData = canvas.toDataURL('image/png');
    // Dodavanje slike u PDF
    const pdf = new jsPDF({
      unit: 'mm',
      format: [1080, 1920]
    });
    pdf.addImage(imgData, 'PNG', 0, 0, 1080, 1920, '', 'FAST'); // Podesite dimenzije prema potrebama

    // Druga strana: parking mapa (poleđina fizičke karte kod duplex štampe)
    const parkingMapData = await getParkingMapDataUrl();
    pdf.addPage([1080, 1920]);
    pdf.addImage(parkingMapData, 'PNG', 0, 0, 1080, 1920, '', 'FAST');

    // Otvoriti PDF u novom prozoru
    const pdfBlob = pdf.output('blob');

    const pdfUrl = URL.createObjectURL(pdfBlob);
    console.log(pdfUrl);
    return pdfBlob;
  };

  const handleSubmit = async event => {
    event.preventDefault();

    const isValidDateTime = value => {
      const date = new Date(value.replace(' ', 'T')); // Zamenite razmak sa 'T' za ISO standard
      return !isNaN(date.getTime());
    };

    if (!isValidDateTime(changeTime)) {
      setErrMsg(t('newTicket.invalidChangeTimeFormat'));
      return;
    }

    let newTickets = []; // Čuva podatke za nove karte

    const periodsString =
      selectedPeriods.length > 0 ? selectedPeriods.join(',') : '';
    const periodsFlag = selectedPeriods.length > 0 ? '1' : '0';

    for (let i = 0; i < ticketCount; i++) {
      const newTicketId = `${Date.now()}${Math.floor(100 + Math.random() * 900)}`;

      const newTicket = {
        ticket_id: newTicketId,
        surname,
        name,
        phone,
        h_from: `${hFrom}:00`,
        h_to: `${hTo}:00`,
        day_no: dayNo,
        entry_no: entryNo,
        daily_no: dailyNo,
        readers: selectedReaders,
        change_time: changeTime,
        create_time: new Date().toISOString().replace('T', ' ').split('.')[0],
        template_id: selectedTemplateGroup,
        registration: registrationPlates,
        reader_group: readerGroup,
        email: email,
        periods: periodsString,
        periods_flag: periodsFlag,
        submitter: getUsername() || 'unknown'
      };

      try {
        const response = await postRequest(
          '/write-qr',
          new URLSearchParams(newTicket)
        );
        if (!response.success) {
          setErrMsg(t('newTicket.somethingWentWrong'));
          return;
        }
        newTickets.push(newTicket); // Dodaj kartu u niz
      } catch (error) {
        setErrMsg(t('newTicket.failedToAddTicket'));
        return;
      }
    }

    setTickets(newTickets); // Ažuriraj state sa svim generisanim kartama
    setSucc(t('newTicket.successfullyAddedAndSentToEmail'));
  };

  const handleReaderChange = e => {
    const { value, checked } = e.target;

    setSelectedReaders(prev => {
      if (value === 'all') {
        return checked ? readers.map(reader => reader.id) : [];
      }
      const id = Number(value);
      return checked ? [...prev, id] : prev.filter(readerId => readerId !== id);
    });
  };

  const handlePeriodChange = periodId => {
    setSelectedPeriods(prev =>
      prev.includes(periodId)
        ? prev.filter(id => id !== periodId)
        : [...prev, periodId]
    );
  };

  const handleSendEmail = async () => {
    const params = {
      email: email,
      tickets: tickets
    };
    //await ticketSendEmail(params);

    // Funkcija koja generiše PDF-ove i postavlja stanje
    const generateAllPdf = async () => {
      const generatedFiles = await Promise.all(
        tickets.map(async (_, index) => {
          const pdfBlob = await generatePDF(index);
          if (!pdfBlob) {
            return null; // Ako PDF nije generisan, preskoči
          }
          return new File([pdfBlob], `ticket-${index + 1}.pdf`, {
            type: 'application/pdf'
          });
        })
      );

      // Filtriraj null vrednosti (ako neki PDF nije generisan)
      const validFiles = generatedFiles.filter(file => file !== null);
      console.log(validFiles);

      if (validFiles.length === 0) {
        alert('No valid PDF files to send.');
        return;
      }

      setPdfFiles(validFiles);
      setIsAllPdfGenerated(true); // Svi PDF-ovi su sada generisani
    };

    setIsFullSize(true);
    // Generisanje PDF-ova
    setTimeout(() => {
      generateAllPdf();
      setIsFullSize(false); // Revert back after PDF conversion
    }, 100);
  };

  // Kada su svi PDF-ovi generisani, šaljemo email
  useEffect(() => {
    if (isAllPdfGenerated && pdfFiles.length > 0) {
      const formData = new FormData();
      formData.append('email', email);
      pdfFiles.forEach(file => formData.append('files[]', file));
      console.log(formData, 'pararara');

      ticketSendEmail(formData)
        .then(() => {
          setEmail('');
        })
        .catch(() => {
          setEmail('');
        });
    }
  }, [isAllPdfGenerated, pdfFiles]);

  return (
    <Container className="container-ticket" sx={{ p: 3, mt: 4 }} maxWidth="sm">
      <Typography variant="h4" sx={{ mb: 4 }}>
        {t('newTicket.newPaperTicket')}
      </Typography>
      <form
        onSubmit={handleSubmit}
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label={t('newTicket.firstName')}
              value={name}
              onChange={e => setName(e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label={t('newTicket.lastName')}
              value={surname}
              onChange={e => setSurname(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label={t('newTicket.phoneNumber')}
              value={phone}
              onChange={e => setPhone(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <Select
              fullWidth
              value={selectedTicketTemplate}
              onChange={e => {
                const templateId = e.target.value;
                setSelectedTicketTemplate(templateId);
                if (templateId) {
                  const template = ticketTemplates.find(
                    t => t.id.toString() === templateId.toString()
                  );
                  if (template) {
                    setHFrom(
                      template.h_from ? template.h_from.substring(0, 5) : hFrom
                    );
                    setHTo(template.h_to ? template.h_to.substring(0, 5) : hTo);
                    setDayNo(template.day_no || dayNo);
                    setEntryNo(template.entry_no || entryNo);
                    setDailyNo(template.daily_no || dailyNo);
                    if (template.readers) {
                      const readersArray =
                        typeof template.readers === 'string'
                          ? template.readers.split(',').map(r => r.trim())
                          : template.readers;
                      setSelectedReaders(readersArray);
                    }
                    if (template.create_time) {
                      setChangeTime(template.create_time);
                    }
                  }
                }
              }}
              displayEmpty
            >
              <MenuItem value="">
                <em>{t('ticketTemplates.selectTemplate')}</em>
              </MenuItem>
              {ticketTemplates.map(template => (
                <MenuItem key={template.id} value={template.id}>
                  {template.name}
                </MenuItem>
              ))}
            </Select>
          </Grid>
          <Grid item xs={6}>
            <TextField
              type="time"
              fullWidth
              label={t('newTicket.entryFrom')}
              value={hFrom}
              onChange={e => setHFrom(e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              type="time"
              fullWidth
              label={t('newTicket.entryUntil')}
              value={hTo}
              onChange={e => setHTo(e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              type="datetime"
              label={t('newTicket.changeTime')}
              fullWidth
              value={changeTime}
              onChange={e => setChangeTime(e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label={t('newTicket.numberOfDaysTheTicketIsValid')}
              value={dayNo}
              onChange={e => setDayNo(e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label={t('newTicket.totalNumberOfEntries')}
              value={entryNo}
              onChange={e => setEntryNo(e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label={t('newTicket.numberOfDailyEntries')}
              value={dailyNo}
              onChange={e => setDailyNo(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              type="number"
              fullWidth
              label={t('newTicket.ticketCount')}
              value={ticketCount}
              onChange={e => setTicketCount(e.target.value)}
            />
          </Grid>
          {cameraMode == '1' && (
            <Grid item xs={12}>
              <TextField
                fullWidth
                label={t('newTicket.readerGroup')}
                value={readerGroup}
                onChange={e => setReaderGroup(e.target.value)}
              />
            </Grid>
          )}
          {mode === '1' && (
            <>
              <Grid item xs={12} sm={6}>
                <Select
                  fullWidth
                  value={selectedTemplateGroup} // Koristi selectedTemplateGroup kao vrednost
                  onChange={e => setSelectedTemplateGroup(e.target.value)} // Postavi samo ID selektovane grupe
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    {t('newTicket.selectGroup')}
                  </MenuItem>
                  {templateGroups.map(group => (
                    <MenuItem key={group.id} value={group.id}>
                      {group.name}
                    </MenuItem>
                  ))}
                </Select>
              </Grid>
            </>
          )}
          {cameraMode === '1' && (
            <Grid item xs={12} sm={6}>
              <TextField
                label={t('newTicket.registrationPlates')}
                fullWidth
                value={registrationPlates}
                onChange={e => setRegistrationPlates(e.target.value)}
              />
            </Grid>
          )}
          <Grid item xs={12} sm={12}>
            <TextField
              label={t('newTicket.email')}
              fullWidth
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Button
              variant="outlined"
              onClick={() => setIsModalOpen(true)}
              fullWidth
            >
              {t('newTicket.selectReader')}
            </Button>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Button
              variant="outlined"
              onClick={() => setIsPeriodsModalOpen(true)}
              fullWidth
            >
              {t('newTicket.selectPeriods')} ({selectedPeriods.length}{' '}
              {t('newTicket.selected')})
            </Button>
          </Grid>
          <Dialog
            open={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            fullWidth
            maxWidth="sm"
          >
            <DialogTitle>{t('newTicket.selectReader')}</DialogTitle>
            <DialogContent>
              <Grid container spacing={2} alignItems="center">
                {/* "Select All" checkbox */}
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectedReaders.length === readers.length}
                        onChange={handleReaderChange}
                        value="all"
                      />
                    }
                    label={t('newTicket.all')}
                  />
                </Grid>

                {/* Individual checkboxes */}
                {readers.map(reader => (
                  <Grid item xs={12} sm={6} key={reader.id}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedReaders.includes(reader.id)}
                          onChange={handleReaderChange}
                          value={reader.id}
                        />
                      }
                      label={reader.name}
                    />
                  </Grid>
                ))}
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => setIsModalOpen(false)}
                sx={{ backgroundColor: '#1976d2', color: 'white' }}
              >
                {t('newTicket.ok')}
              </Button>
            </DialogActions>
          </Dialog>

          {/* Periods Selection Modal */}
          <Dialog
            open={isPeriodsModalOpen}
            onClose={() => setIsPeriodsModalOpen(false)}
            fullWidth
            maxWidth="sm"
          >
            <DialogTitle>{t('newTicket.selectPeriods')}</DialogTitle>
            <DialogContent>
              <Grid container spacing={1}>
                {periods.map(period => (
                  <Grid item xs={12} sm={6} key={period.id}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedPeriods.includes(
                            period.id.toString()
                          )}
                          onChange={() =>
                            handlePeriodChange(period.id.toString())
                          }
                        />
                      }
                      label={`${period.start} - ${period.end} (${period.number_of_passes} ${t('period.passes')})`}
                    />
                  </Grid>
                ))}
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => setIsPeriodsModalOpen(false)}
                variant="contained"
                color="primary"
              >
                {t('newTicket.ok')}
              </Button>
            </DialogActions>
          </Dialog>
          <Box
            item
            xs={12}
            sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}
          >
            <Button
              sx={{ width: '50%' }}
              onClick={() => setIsTicketModalOpen(true)}
              variant="contained"
              type="submit"
            >
              {t('newTicket.add')}
            </Button>
          </Box>
        </Grid>
      </form>

      {tickets.length > 0 && (
        <Box mt={0}>
          <Typography variant="h6" gutterBottom>
            {t('newTicket.generatedTickets')}
          </Typography>
          {tickets.map((ticket, index) => (
            <Box
              key={index}
              ref={el => (ticketRefs.current[index] = el)}
              sx={{
                width: '1080mm',
                height: '1920mm',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: mode == '1' ? 'space-between' : 'center',
                position: 'relative',
                backgroundColor: '#fff',
                overflow: 'hidden',
                padding: '0',
                zoom: isFullSize ? { xs: '1' } : { xs: '0.1' }
              }}
            >
              <Box
                className="image-parking-container"
                sx={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'stretch',
                  backgroundColor:
                    templateGroups.find(g => g.id === ticket.template_id)
                      ?.color || '#001d4f'
                }}
              >
                <Box className="image" sx={{ width: '50%' }}>
                  <CZLogo
                    primaryColor={
                      templateGroups.find(g => g.id === ticket.template_id)
                        ?.color || '#001d4f'
                    }
                    width={'100'}
                  ></CZLogo>
                </Box>
                <Box
                  className="parking"
                  sx={{
                    width: '50%',
                    height: 'auto',
                    backgroundColor:
                      templateGroups.find(g => g.id === ticket.template_id)
                        ?.color || '#001d4f',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <Typography
                    sx={{
                      color: '#fff',
                      fontSize: '7000%',
                      fontFamily: 'CoFoPeshka',
                      fontWeight: 600
                    }}
                  >
                    {ticket.reader_group.charAt(0)}
                    <span style={{ fontSize: '0.5em' }}>
                      {ticket.reader_group.slice(1)}
                    </span>
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  width: '100%',
                  paddingTop: '7%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'space-around'
                }}
              >
                <Box
                  className="QR"
                  sx={{
                    display: 'flex',
                    width: '100%',
                    margin: '0% 0',
                    justifyContent: 'center'
                  }}
                >
                  <QRCodeSVG value={ticket.ticket_id} size="2200" />
                </Box>
                <Box
                  sx={{
                    textTransform: 'uppercase',
                    lineHeight: 1.3,
                    display: 'flex',
                    flexDirection: 'column',
                    paddingTop: '15%',
                    paddingBottom: '0%',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '70%',
                    fontFamily: 'Arial, sans-serif',
                    fontWeight: 'bold',
                    fontSize: '500%'
                  }}
                >
                  <Box className="ticket-info" sx={{ width: '100%' }}>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: '100%',
                        wordSpacing: 'normal'
                      }}
                    >
                      <Box sx={{ textAlign: 'left' }}>Ime i prezime:</Box>
                      <Box
                        sx={{
                          display: 'inline-flex',
                          flexWrap: 'wrap',
                          justifyContent: 'flex-end',
                          textAlign: 'right',
                          maxWidth: '100%'
                        }}
                      >
                        <span>{ticket.name}&nbsp;</span>
                        <span>{ticket.surname}</span>
                      </Box>
                    </Box>
                    {cameraMode == '1' && (
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          width: '100%',
                          wordSpacing: 'normal'
                        }}
                      >
                        <Box sx={{ textAlign: 'left' }}>Reg broj vozila:</Box>
                        <Box sx={{ textAlign: 'right' }}>
                          {ticket.registration}
                        </Box>
                      </Box>
                    )}
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: '100%',
                        wordSpacing: 'normal'
                      }}
                    >
                      <Box sx={{ textAlign: 'left' }}>Validna od:</Box>
                      <Box sx={{ textAlign: 'right' }}>
                        {ticket.change_time
                          .split(' ')[0]
                          .split('-')
                          .reverse()
                          .join('-')}
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: '100%',
                        wordSpacing: 'normal'
                      }}
                    >
                      <Box sx={{ textAlign: 'left' }}>Validna do:</Box>
                      <Box sx={{ textAlign: 'right' }}>
                        {ticket.day_no == '0'
                          ? 'Neograničeno'
                          : (() => {
                              const [datePart, timePart] =
                                ticket.change_time.split(' ');
                              const [year, month, day] = datePart.split('-');
                              const date = new Date(year, month - 1, day);
                              date.setDate(
                                date.getDate() + parseInt(ticket.day_no) - 1
                              );
                              return `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()}`;
                            })()}
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
              {cameraMode == '1' && (
                <Box
                  className="cardType"
                  sx={{
                    display: 'flex',
                    backgroundColor:
                      templateGroups.find(g => g.id === ticket.template_id)
                        ?.color || '#001d4f',
                    width: '100%',
                    marginTop: '5%',
                    justifyContent: 'center'
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: 'CoFoPeshka',
                      color: 'white',
                      fontSize: '1900%',
                      fontWeight: '600'
                    }}
                  >
                    PARKING KARTA
                  </Typography>
                </Box>
              )}
            </Box>
          ))}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              paddingTop: '2%'
            }}
          >
            <Button
              sx={{ width: '100%' }}
              variant="contained"
              onClick={handleSendEmail}
              disabled={!email}
            >
              {t('newTicket.send')}
            </Button>
          </Box>
        </Box>
      )}

      {errMsg && <Error message={errMsg} onClose={() => setErrMsg('')} />}
      {succ && <Success message={succ} onClose={() => setSucc('')} />}
    </Container>
  );
};

export default QRGenerateTicket;
